import React, { useEffect } from 'react'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import { useIntl } from 'src/common/razzle-platform-translate'
import { useMobileDetector } from 'src/common/razzle-platform-components/hooks/mobile-detector'
import './reservation-indicators.css'


const useStyles = makeStyles((theme) => ({
    bodyContainer: {
        display: 'flex',
        paddingLeft: 21,
        paddingRight: 21,
        paddingTop: 0,
        paddingBottom: 12,
    },
    indicator: {
        height: 15,
        width: 15,
        borderRadius: 4,
        marginRight: 7,
        border: '1px solid #0000002e',
    },
    indicatorsContainer: {
        flexDirection: 'row',
        justifyContent: 'space-around'
    },
    indicatorOfPeriodicity: {
        paddingLeft: 3,
        fontWeight: 'bolder',
        fontSize: 10
    },
    indicatorNotAvailable: {
        background: '#e4e7e7b5'
    },
    indicatorContent: {
        display: 'flex',
        alignItems: 'center'
    },
    indicatorsMobile: {
        flexDirection: 'column'
    },
}))



const Indicators = (props) => {
    const { periodicities } = props
    const classes = useStyles()
    const { formatMessage } = useIntl()
    const { isMobile } = useMobileDetector()

    return (
        <div
            className={classNames(classes.bodyContainer, classes.indicatorsContainer, {
                [classes.indicatorsMobile]: isMobile
            })}
        >
            <div className={classes.indicatorContent}>
                <div className={classNames(classes.indicator, classes.indicatorNotAvailable)} />
                <Typography>{ formatMessage({ id: 'Non Disponible', defaultMessage: 'Non Disponible' }) }</Typography>
            </div>
            { periodicities && periodicities.map(periodicity => (
                <div className={classes.indicatorContent} key={periodicity.id} >
                    <div className={classNames(classes.indicator, classes.indicatorOfPeriodicity, `periodicity-bg-${periodicity.id}`)}></div>
                    <Typography>{periodicity.label}</Typography>
                </div>
            ))}
        </div>
    )
}

export default Indicators
